jQuery(document).ready(function ($) {
    // Retrocede en el historial del navegador
    $('#goBack').click(function () {
        var previousUrl = document.referrer;
        var currentUrl = window.location.href;

        if (!previousUrl) {
            // Si la URL actual contiene "postular-para-vacante", redirigir a "vacancies"
            if (currentUrl.includes("postular-para-vacante")) {
                previousUrl = window.location.origin + "/vacancies";
            } else if (currentUrl.includes("contactar-ocasion")) {
                previousUrl = window.location.origin + "/ocasion";
            } else {
                // Eliminar la última barra de la URL actual si existe
                if (currentUrl.charAt(currentUrl.length - 1) === '/') {
                    currentUrl = currentUrl.slice(0, -1);
                }
        
                // Encontrar la posición de la última barra antes de la página actual
                var lastSlashIndex = currentUrl.lastIndexOf('/');
                if (lastSlashIndex !== -1 && lastSlashIndex > currentUrl.lastIndexOf('//') + 1) {
                    previousUrl = currentUrl.substring(0, lastSlashIndex + 1);
                }
            }
        }        

        window.location.href = previousUrl;

    });

    // Botón de desplazamiento suave
    $('#scrollButton').on('click', function () {
        var scrollTo = $(this).data('scroll-to');
        var $target = $('#' + scrollTo);

        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 300);
        }
    });

    jQuery(document).ready(function ($) {
        // Botón de desplazamiento suave
        $('#scrollButton').on('click', function () {
            var scrollTo = $(this).data('scroll-to');
            var $target = $('#' + scrollTo);

            if ($target.length) {
                $('html, body').animate({
                    scrollTop: $target.offset().top
                }, 300);
            }
        });

        // Mostrar/Ocultar contenido emergente al pasar el ratón
        $('.popup-container').hover(
            function () {
                $(this).find('svg').hover(
                    function () {
                        $(this).siblings('.companies-popup-content').css('display', 'inline-block');
                    },
                    function () {
                        $(this).siblings('.companies-popup-content').css('display', 'none');
                    }
                );
            },
            function () {
                $(this).find('.companies-popup-content').css('display', 'none');
            }
        );
    });

});



